// Dados dos depoimentos
export interface Testimonial {
  id: string;
  name: string;
  role: string;
  image: string;
  quote: string;
}

export const testimonials: Testimonial[] = [
  {
    id: '1',
    name: 'Renan',
    role: 'Cliente proNotas',
    image: 'https://ui-avatars.com/api/?name=Renan&background=4CAF50&color=fff&size=128',
    quote: 'Se eu pudesse descrever o proNotas em uma única palavra, seria: facilitador de vidas. É um sistema que tem tudo dentro dele! Para quem está começando e para quem já está mais avançado, o proNotas é super recomendado. Indicamos ele para todo mundo!',
  },
  {
    id: '2',
    name: 'Bruno',
    role: 'Diretor Financeiro e Cliente proNotas',
    image: 'https://ui-avatars.com/api/?name=Bruno&background=4CAF50&color=fff&size=128',
    quote: 'Além do proNotas facilitar a rotina e conseguir repassar pedidos do dia com uma agilidade muito grande, também vem me ajudando em todos os processos financeiros da nossa empresa, como contas a pagar e receber.',
  },
  {
    id: '3',
    name: 'Ivan',
    role: 'Empresário e Cliente do proNotas',
    image: 'https://ui-avatars.com/api/?name=Ivan&background=4CAF50&color=fff&size=128',
    quote: 'O proNotas vem sendo uma excelente ferramenta para acompanhar nossas vendas, pedidos, compras e faturamento. Ele organiza inclusive a nossa logística, como vendemos na loja virtual e em vários marketplaces, a centralização dos pedidos no proNotas traz uma organização perfeita.',
  },
  {
    id: '4',
    name: 'Fernanda',
    role: 'Empresária e Cliente proNotas',
    image: 'https://ui-avatars.com/api/?name=Fernanda&background=4CAF50&color=fff&size=128',
    quote: 'O principal diferencial é o suporte. Qualquer problema que tenho, eu ligo no suporte e sou bem atendida. Foi através do suporte que aprendi a usar o proNotas e foi através dele que consegui fazer a integração com outras plataformas.',
  },
];
